import { FC, ImgHTMLAttributes, CSSProperties } from 'react';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fill?: boolean;
  layout?: 'fill';
  objectFit?: CSSProperties['objectFit'];
  priority?: boolean;
  quality?: number;
  sizes?: string;
}

const Image: FC<ImageProps> = ({
  fill,
  layout,
  objectFit,
  priority: _priority,
  quality: _quality,
  sizes: _sizes,
  className = '',
  style,
  loading = 'lazy',
  ...props
}) => {
  const shouldFill = fill || layout === 'fill';
  const mergedStyle = objectFit ? { ...style, objectFit } : style;

  if (shouldFill) {
    return (
      <img
        {...props}
        loading={loading}
        className={`absolute inset-0 h-full w-full object-cover ${className}`}
        style={mergedStyle}
      />
    );
  }

  return <img {...props} loading={loading} className={className} style={mergedStyle} />;
};

export default Image;
